import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useClient } from '../../common/ClientProvider';
import { ClientConfigService } from './ClientConfigService';

interface ClientConfigServiceProviderProps {
    children: React.ReactNode;
}

const ClientConfigServiceContext = React.createContext<ClientConfigService | undefined>(undefined);

export const ClientConfigServiceProvider: React.FC<ClientConfigServiceProviderProps> = ({ children }) => {
    const { getAccessTokenSilently } = useAuth0();
    const { currentClientId } = useClient();

    const service = React.useMemo(
        () => new ClientConfigService(getAccessTokenSilently, currentClientId),
        [getAccessTokenSilently, currentClientId]
    );

    return (
        <ClientConfigServiceContext.Provider value={service}>
            {children}
        </ClientConfigServiceContext.Provider>
    );
};

export const useClientConfigService = (): ClientConfigService => {
    const context = React.useContext(ClientConfigServiceContext);
    if (context === undefined) {
        throw new Error('useClientConfigService must be used within a ClientConfigServiceProvider');
    }
    return context;
};
